import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "menu"
    }}>{`Menu`}</h1>
    {
      /* > Please follow this video with the documentation, and it'll make the menu build process relatively easy. */
    }
    {
      /* <iframe width="1024" height="600" src="https://www.youtube.com/embed/ewNGG_i3r-Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */
    }
    <p>{`Mega menu for the `}<inlineCode parentName="p">{`shop`}</inlineCode>{` are coming from a typescript file which is located at,`}</p>
    <pre><code parentName="pre" {...{}}>{`shop -> src -> data -> static -> menus.ts
`}</code></pre>
    <p><img alt="MenusJson.png" src={require("./images/MenusJson.png")} /></p>
    <p>{`You've to update this JSON to build the mega menu.`}</p>
    <h3 {...{
      "id": "data-structure"
    }}>{`Data Structure`}</h3>
    <pre><code parentName="pre" {...{}}>{`id -> ID for menu or submenu
path -> After clicking the menu in frontend which path will be redirect
label -> Label of that men
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`subMenu -> Object for submenu
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`mobileMenu -> Different menu for mobile.
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      